import { User } from '@dc-shared-web/hooks/api/user/types'
import { uploadUserProfileImage } from '@dc-shared-web/hooks/api/user/uploadUserProfileImage'
import { useSvcCrunchesContext } from '@dc-shared-web/providers'
import { useMutation, useQueryClient } from 'react-query'

export const useUploadUserProfileImage = (userId: string) => {
  const svcCrunchesApiClient = useSvcCrunchesContext()
  const queryClient = useQueryClient()

  return useMutation(
    async (file: File) => {
      const response = await uploadUserProfileImage(svcCrunchesApiClient, {
        userId,
        picture: file,
      })

      return response
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries<User>(`user-${userId}`)
      },
    }
  )
}
